import { Link } from "react-router-dom";
import { motion } from "framer-motion";

export default function SiteNav() {
  return (
    <motion.header
      data-testid="site-nav"
      className="fixed top-0 inset-x-0 z-50 glass-panel border-x-0 border-t-0"
      initial={{ y: -60, opacity: 0 }}
      animate={{ y: 0, opacity: 1, transition: { delay: 0.4, duration: 0.8 } }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-8 flex items-center justify-between h-16 sm:h-20">
        <Link to="/" data-testid="nav-brand-link" className="font-serif text-lg sm:text-xl tracking-[0.25em] uppercase text-amber-100/95">
          Monroe <span className="gold-text italic">Society</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-xs uppercase tracking-[0.2em] text-neutral-400">
          <a href="/#directory" data-testid="nav-directory-link" className="hover:text-gold transition-colors duration-300">Directory</a>
          <Link to="/membership" data-testid="nav-membership-link" className="hover:text-gold transition-colors duration-300">Membership</Link>
          <Link to="/boutique" data-testid="nav-boutique-link" className="hover:text-gold transition-colors duration-300">Boutique</Link>
          <a href="/#standards" data-testid="nav-standards-link" className="hover:text-gold transition-colors duration-300">Standards</a>
        </nav>
        <div className="flex items-center gap-3">
          <Link
            to="/signin"
            data-testid="nav-signin-link"
            className="hidden sm:inline-block px-5 py-2 text-xs uppercase tracking-[0.2em] text-neutral-300 hover:text-gold transition-colors duration-300"
          >
            Sign In
          </Link>
          <Link
            to="/join/provider"
            data-testid="nav-join-provider-button"
            className="px-5 py-2.5 bg-gold text-obsidian text-xs uppercase tracking-[0.2em] font-medium hover:bg-gold-bright transition-colors duration-300"
          >
            Advertise
          </Link>
        </div>
      </div>
    </motion.header>
  );
}
